module.exports = __webpack_public_path__ + "static/database-e52e17043b4d2f8a5fdba2bff33812b6.svg";